import React from 'react';
import ValidationMessage from '../../validation/ValidationMessage';
import Select from '../niceSelect';

const Input = ({ errorMessage, valid, t, type, value, options, label, ...rest }) => (
  <React.Fragment>
    <h5><label htmlFor={rest.name}>{label}</label></h5>
    <Select defaultValue={value} {...rest} optionList={options} cssClass="form-control-modal form-control nicelist100" />
    <ValidationMessage message={errorMessage} valid={valid} />
  </React.Fragment>
);

Input.propTypes = {
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/form/select/Select.jsx